export type CheckSource = "ai" | "rule";

export function SourceBadge({ source }: { source?: CheckSource }) {
  if (!source) return null;
  return (
    <span className="text-[10px] text-gray-400 font-mono uppercase">
      {source === "ai" ? "AI" : "Rule"}
    </span>
  );
}
